export enum DetailType {
  STRING = 'STRING',
  DOKUMENT = 'DOKUMENT',
  DATE = 'DATE',
  ENUM = 'ENUM',
}

export enum SearchCategory {
  PJESEMARRES = 'PJESEMARRES',
  TRAJNIMI = 'TRAJNIMI',
  DOKUMENT = 'DOKUMENT',
  EKSPERT_TRAJNIMI = 'EKSPERT_TRAJNIMI',
  TRAJNIM_PREZENCA = 'TRAJNIM_PREZENCA',

  //KONKURRIME
  KONKURRENT = 'KONKURRENT',

  //FF
  PEDAGOG = 'PEDAGOG',
  KANDIDAT = 'KANDIDAT',
  LISTE_PREZENCA = 'LISTE_PREZENCA',
  LENDA = 'LENDA',
  EVIDENCA = 'EVIDENCA',
}
